<template>
  <div>
    <el-row :gutter="20" v-if="$route.path.indexOf('_detail') === -1 && $route.path.indexOf('_edit') === -1 ">
      <el-col :span="4">
        <el-select v-model="type" @change="typeSelectHandle" placeholder="商品类型"
                   style="width: 100%;">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="标题" v-model="title"><el-button slot="append" icon="el-icon-search" @click="titleSearch"></el-button></el-input>
      </el-col>
      <el-col :span="6" >
        <el-date-picker v-model="created" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" ></el-date-picker>
      </el-col>
      <el-col :span="4">
        <el-select size="small" v-model="category_id" clearable placeholder="商品分类" @change="search">
          <el-option v-for="item in category" :key="item.value" :label="item.name" size="mini" :value="item.category_id"> </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div v-if="$route.path.indexOf('_detail') === -1 && $route.path.indexOf('_edit') === -1 ">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button-group>
            <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="add()">新增商品</el-button>
            <el-button type="primary" size="small" icon="el-icon-edit" @click="changeStatus(1)">批量上架</el-button>
            <el-button type="primary" size="small" icon="el-icon-edit" @click="changeStatus(0)">批量下架</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-table
        :data="dataList"
        style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选" ></el-table-column>
        <el-table-column
          prop="goods_id"
          label="商品id">
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题">
        </el-table-column>
        <el-table-column
          label="图片"
          width="180">
          <template slot-scope="scope">
            <img :src="scope.row.goods_info[0].pics" alt="" style="width: 60px">
          </template>
        </el-table-column>
        <el-table-column
          label="商品名称"
          width="180">
          <template slot-scope="scope">
           {{scope.row.goods_info[0].item_title}}
          </template>
        </el-table-column>

        <el-table-column
          prop="description"
          label="描述">
        </el-table-column>
        <el-table-column
          prop="type"
          label="过期方式">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.type == 0">灵活过期</el-tag>
            <el-tag v-else>统一过期</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="是否可用"
          width="180">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.is_can_use == 1">是</el-tag>
            <el-tag v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row.goods_id)">编辑</el-button>
            <el-button type="text" @click="del(scope.row.goods_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="content-padded content-center" v-if="pagers.total>0">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="fetchParams.page"
          :page-sizes="[10,20,50,100]"
          :total="pagers.total"
          :page-size="fetchParams.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { deleteGoods,getCategoryList,getGoodsList,changeStatus} from '@/api/long'

export default {
  props: {
    isLoad: {
      type: Boolean,
      default: true
    },
  },
  provide() {
    return {
      refresh: this.getList
    }
  },
  data () {
    return {
      goods_id:'',
      loading: false,
      dataList: [],
      pagers:{
        total: 0
      },
      created:'',
      category:[],
      category_id:'',
      title:'',
      type:'',
      options: [
        {value: 0, label: '灵活过期'},
        {value: 1,label: '统一过期'}
      ],
      pageSize:20,
      currentPage:1,
      params: {},
      fetchParams: {
        page: 1,
        begin_time:'',
        end_time:'',
        title:'',
        type:'',
        pageSize: 20,
        goods_id:'',
      },
      ids:[],
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  watch:{
    $route(to,from){
      this.getList()
    }
  },
  methods: {
    // 新增
    add(){
      this.$router.push({path: this.matchHidePage('edit')})
    },
    handleCurrentChange(val) {
      this.fetchParams.page = val
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.fetchParams.page = 1
      this.fetchParams.pageSize = pageSize
      this.getList()
    },
    titleSearch(){
      this.fetchParams.title = this.title
      this.params.page = 1
      this.getList()
    } ,
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    typeSelectHandle(){
      this.fetchParams.type = this.type
      this.params.page = 1
      this.getList()
    },
    dateChange (val) {
      if(val) {
        if (val.length > 0) {
          this.fetchParams.begin_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.fetchParams.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
          this.fetchParams.begin_time = ''
          this.fetchParams.end_time = ''
        }
      }else{
        this.fetchParams.begin_time = ''
        this.fetchParams.end_time = ''
      }
      this.params.page = 1
      this.getList()
    },
    del (id, index) {
      var that=this
      this.$confirm('确定要删除该商品？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            deleteGoods(id).then( res => {
              if(res.status){
                this.$message({
                  message: '已删除',
                  type: 'success',
                  duration: 2000
                })
                setTimeout(function (){
                  that.dataList.splice(index, 1)
                },1000)

              }

            })
          }
          done()
        }
      })
    },
    getList () {
      this.loading = true
      var params = {
        status: this.fetchParams.status,
        card_type: this.fetchParams.card_type,
        page_no: this.fetchParams.currentPage,
        pageSize: this.fetchParams.pageSize,
        begin_time: this.fetchParams.begin_time,
        end_time: this.fetchParams.end_time,
        type: this.fetchParams.type,
        category_id:this.category_id,
        title:this.fetchParams.title,
        goods_id:this.fetchParams.goods_id
      }
      // alert(this.fetchParams.kaquanstatus)
      getGoodsList(params).then(res => {
        if(res.data.data.list.length > 0) {
          this.dataList = res.data.data.list
          this.pagers.total = res.data.data.total_count
          this.loading = false
        } else {
          this.dataList = []
          this.loading = false
        }
      })
        .catch( error => {
          this.loading = false
        })
    },
    filterTag (value) {
      if (value.type) {
        this.fetchParams.type = value.type
        this.getList()
      }
    },
    handleSelectionChange (val) {
      let ids = []
      for (let i in val) {
        ids.push(val[i].goods_id)
      }
      this.ids = ids
    },
    //  上架下架
    changeStatus(val){
      if(this.ids.length<1){
        this.$message({message:'请先选择一个商品！',type: 'warning'});
        return false;
      }
      changeStatus({id:this.ids,is_can_use:val}).then(res=>{
          if(res.data.status){
            if(val == 1){
              this.$message({message:'已上架！',type: 'success'});
            }else{
              this.$message({message:'已下架！',type: 'success'});
            }
            this.getList();
          }
      })

    },
    search () {
      this.fetchParams.category_id = this.category_id
      this.getList()
    },
    edit(id){
      this.$router.push({path: this.matchHidePage('edit'),query:{id:id}})
    }
  },
  mounted () {
    getCategoryList({}).then(res=>{
      if(res.data){
        this.category = res.data.data
      }
    })
    this.$nextTick(() => {
      if (this.isLoad) {
        this.getList()
      }
    })
  }
}

</script>
<style scoped lang="scss">
.el-icon-edit {
  cursor: pointer;
}
.coupon-list {
  margin-top: 10px;
}
.coupon-item {
  position: relative;
  height: 130px;
  padding: 25px 20px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dadadd;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  width: 19%;
  float: left;
  margin: .5%;
  &.coupon-add {
    padding-top: 20px;
    cursor: pointer;
    i {
      font-size: 40px;
    }
    :last-child { margin-top: 10px; }
  }
  .price {
    font-size: 24px;
  }
  .color-gray {
    color: #99A9BF;
  }
  .color-gray-deep {
    color: #8492A6;
  }
  .item-code {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span.icon-triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 34px solid #20a0ff;
    border-left: 34px solid transparent;
    color: #fff;
  }
  label {
    position: absolute;
    top: -34px;
    right: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
}
.item-bg {
  position: absolute;
  left: 0;
  bottom: -101%;
  width: 100%;
  height: 100%;
  background: rgba(241, 244, 246, .9);
  text-align: left;
  border-radius: 5px;
  padding-top: 8px;
  transition: all .4s ease;
  p {
    padding: 0 10px;
  }
  .item-operate {
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .4);
    width: 100%;
    padding: 4px 0;
    text-align: center;
    cursor: pointer;
    a { color: #fff; }
  }
}
.coupon-item:hover {
  .item-bg {
    bottom: 0;
  }
}
.coupon-type-item {
  position: relative;
  padding: 30px 10px;
  border: 1px solid #ff5000;
  color: #ff5000;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 20px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  &:first-child {
    font-size: 18px;
  }
  .coupon-type-desc {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: -100%;
    left: 0;
    padding: 10px 0;
    background: #ff5000;
    color: #fff;
    font-size: 18px;
    transition: all .4s ease;
    div:last-child {
      width: 70%;
      margin: 8px auto 0;
      font-size: 12px;
    }
  }
  &:hover {
    .coupon-type-desc {
      bottom: 0;
    }
  }
}

.coupon-type-item, .sendout-item {
  overflow: hidden;
  .icon-checked {
    display: none;
    width: 100px;
    height: 25px;
    transform: rotate(35deg);
    position: absolute;
    font-size: 14;
    top: 5px;
    right: -25px;
    font-size: 20px;
    color: #fff;
    background: #ff5000;
    i {
      transform: rotate(-35deg);
    }
  }
  &.checked {
    .icon-checked {
      display: block;
    }
  }

  &:hover .icon-checked {
    background: #fff;
    i {
      color: #ff5000;
    }
  }
}
.store-pop {
  padding: 20px 15px;
  .store-content {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?7db71eab